export default __webpack_public_path__ + "static/media/download.inline.b5360e79.svg";